import invariant from 'invariant';
import { pipe } from 'rxjs';
import { map as rxMap, share, withLatestFrom } from 'rxjs/operators';
import { createFieldRecord } from '../../../utils/data';
import { invariantFieldArray } from '../../../utils/invariant';
import { fieldType } from '../../../validations/constants';
import { getFieldsToValidateFromDescriptor } from '../../../validations/utils';
import { actionNames } from '../../transfer/control';
import { updateValidationResultMultiple, validationRunner } from '../../transfer/transmission';
import { filterByActionType } from '../../utils';
const fieldsToResult = (fields, pristine)=>{
    const result = Object.fromEntries(fields.map(([fieldName, fieldIndices])=>[
            createFieldRecord(fieldName, fieldIndices),
            []
        ]));
    const meta = pristine ? {
        pristine: Object.keys(result)
    } : {};
    return [
        result,
        meta
    ];
};
const expandCleanFields = ({ formData$, formDescriptor$ })=>pipe(withLatestFrom(formData$, formDescriptor$), rxMap(([{ payload = [], meta: { pristine = false } = {} }, formData, formDescriptor])=>{
        if (payload.length === 0) {
            return fieldsToResult(getFieldsToValidateFromDescriptor(formDescriptor, formData), pristine);
        }
        const expandedFields = payload.map((field)=>Array.isArray(field) ? field : [
                field
            ]).map(([fieldName, indices])=>{
            const fieldDescriptor = formDescriptor[fieldName];
            invariant(fieldDescriptor, `field descriptor is not found for fieldName ${fieldName}`);
            if (fieldDescriptor.type === fieldType.ARRAY) {
                return getFieldsToValidateFromDescriptor(Object.fromEntries(Object.entries(formDescriptor).filter(([key, value])=>value.type === fieldType.ARRAY && key === fieldName || value.array === fieldName)), formData);
            }
            invariantFieldArray(fieldDescriptor, fieldName, indices);
            return [
                [
                    fieldName,
                    indices
                ]
            ];
        }).flat();
        return fieldsToResult(expandedFields, pristine);
    }));
export default (({ control$, ...other$ })=>{
    return control$.pipe(filterByActionType(actionNames.CLEAR_FIELDS_ERRORS), expandCleanFields(other$), rxMap(([payload, meta])=>updateValidationResultMultiple(payload, validationRunner.ALL, meta)), share());
});
